<template>
  <b-col>
    <b-card
      v-if="!id"
      sub-title="Všetky moje vianočné pohľadnice a vázičky"
      header="...❄Vianoce❄"
      text-variant="dark"
    >
      <b-row>
        <b-col
          v-for="(item, index) in data"
          :key="index"
          deck
          sm="12"
          md="6"
          lg="4"
          style="margin-top:10px"
        >
          <postcard
            :source-pictutes="data[index].pictutes"
            :title-img="data[index].title"
            :details-img="data[index].details"
            :size-img="data[index].size"
            :material-img="data[index].material"
            :kind-img="data[index].img"
            :path-img="/vianoce/ + data[index].id"
          />
        </b-col>
      </b-row>
    </b-card>
    <router-view/>
  </b-col>
</template>

<script>
import Picture from "./Picture"
import { ref, watch } from "@vue/composition-api"
export default {
  name: 'Vianoce',
  components: {
    'postcard': Picture
  },
  setup(params, context) {
    const id = ref(false)
    if (context.root.$route.params.id) {
      id.value = true
    }
    watch(() => context.root.$route.params.id, (value) => { value ? id.value = true : id.value = false })
    const data = ref([
      {
        pictutes: ['/static/images/vianoce/vianoce1.jpg','/static/images/vianoce/vianoce2.jpg','/static/images/vianoce/vianoce3.jpg','/static/images/vianoce/vianoce4.jpg'],
        title: "Linecké pečivo - 4,50 €",
        subtitle: "Pohľadnica",
        details: "...skladom len tento jedinečný kúsok ! ...sladké a voňavé linecké koláčiky plnené domácim ríbezľovým džemom u starkej na stole, ktorý práve utrela bielou ľanovou utierkou, len tak od práškového cukru, aby sme nemali biele rukávy :) ...vianočná pohľadnička plná spomienok, ozdobená je lineckým srdiečkom, ktoré som 'upiekla' technikou decoupage, nalepila na bielu čipku a ozdobila červenou šnúrkou. Ku pohľadničke posielam pevnú ručne robenú obálku na mieru.",
        size: "14,5 x 10,5 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 24
      },
      {
        pictutes: ['/static/images/vianoce/vianoce5.jpg','/static/images/vianoce/vianoce6.jpg','/static/images/vianoce/vianoce7.jpg'],
        title: "Šťastný nový rok - 4,70 €",
        subtitle: "Pohľadnica",
        details: "...všetkým priaznivcom (trocha v predstihu) prajem spolu so sovičkou ako symbolom múdrosti, pohodový a veselý posledný deň roka a múdre rozhodnutia v prichádzajúcom roku 2020 :) ...otváracia novoročná pohľadnica s motívom sivej sovičky, ktorú som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte na ručne vyrobený pohľadnicový základ v bielej farbe, pohľadničku som dozdobila trblietavými hviezdičkami a pečiatkou -šťastný nový rok-. Pridanou hodnotou tejto novoročnej pohľadničky je ručne robená obálka na mieru.",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, kartón",
        kind: "decoupage, lepenie, cardmaking",
        id: 23
      },
      {
        pictutes: ['/static/images/vianoce/vianoce8.jpg','/static/images/vianoce/vianoce9.jpg','/static/images/vianoce/vianoce10.jpg'],
        title: "Srnka - 6 €",
        subtitle: "Váza",
        details: "...skladom len táto jediná ! ...krásna zimná váza poslúži ako efektná dekorácia počas zimných dní :) no môže poslúžiť aj ako dekorácia do detskej izbičky, na uschovanie drobných vecí (loptičky, pečiatky, pásky :) ) ...milá minimalistická váza s motívom srnky :)...táto vázička vznikla recykláciou ♻️ - odstránila som etiketky, dôkladne umyla a odmastila, precízne som naniesla bielu akrylovú farbu a srnku som aplikovala pomocou decoupage techniky. Celú vázičku som nakoniec pretrela nezávadným ekologickým lakom a potom som uviazala lesklú červenú šnúročku.",
        size: "výška 17,5 cm, priemer vrchného otvoru 7,5 cm",
        material: "sklenený polotovar, špagát",
        kind: "recyklácia, decoupage, lepenie",
        id: 22
      },
      {
        pictutes: ['/static/images/vianoce/vianoce11.jpg','/static/images/vianoce/vianoce12.jpg','/static/images/vianoce/vianoce13.jpg'],
        title: "Hviezdička - 3,50 €",
        subtitle: "Pohľadnica",
        details: "...v tej vianočnej pohľadničke sa spája ľudový nádych s moderným výzorom :) kombinácia šitej ozdôbky s čipkou v minimalistickom vzhľade sa preto bude hodiť ako do chalúpky tak do moderného interiéru :) ...hviezdičku na pohľadničke som vyrobila technikou decoupage, ručne vyrezala a nalepila v 3D efekte, ozdobila som ju bielučkou čipkou a červenou mašličkou. Pridanou hodnotou tejto pohľadničky je nielen ručne robený základ, ale aj handmade obálka na mieru :)",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 21
      },
      {
        pictutes: ['/static/images/vianoce/vianoce14.jpg','/static/images/vianoce/vianoce15.jpg','/static/images/vianoce/vianoce16.jpg'],
        title: "domčeky - 3,60 €",
        subtitle: "Pohľadnica",
        details: "...hviezdičky nad kostolíkom a dreveničkou :) ...vianočná pohľadnička s motívom domčekov a hviezdičiek v sebe prináša pokoj adventných dní a čaro Štedrého večera, motívy boli vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D efekte. Pohľadnička je vrstvená, bez textov a posielam ju s pevnou ručne robenou obálkou na mieru.",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, kartón",
        kind: "decoupage, lepenie, cardmaking",
        id: 20
      },
      {
        pictutes: ['/static/images/vianoce/vianoce17.jpg','/static/images/vianoce/vianoce18.jpg','/static/images/vianoce/vianoce19.jpg'],
        title: "Vanilkové rožky - 4,50 €",
        subtitle: "Pohľadnica",
        details: "...skladom len tento jedinečný kúsok ! ...sladké vanilkové rožky rozplývajúce sa na jazyku, to je tá pravá chuť vianočných sviatkov, tak ako minulý rok aj tento rok som ich napiekla aj na tejto pohľadničke :) ...rožteky sú vytvorené technikou decoupage, ručne vyrezané a nalepené na bielu čipku, dozdobené jemnou bielou šnúrkou. Ku pohľadničke posielam ručne robenú obálku na mieru.",
        size: "cca 14,5 x 10,5 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 19
      },
      {
        pictutes: ['/static/images/vianoce/vianoce20.jpg','/static/images/vianoce/vianoce21.jpg','/static/images/vianoce/vianoce22.jpg'],
        title: "Srnka - 4,10 €",
        subtitle: "Pohľadnica",
        details: "...radosť obdarovať druhého, to je čaro Vianoc :) ...roztomilá vianočná pohľadnica s motívom lesných zvieratiek, ten bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte, pohľadnička je dozdobená trblietkavými vločkami a pečiatkou. Posielam s pevnou ručne robenou obálkou na mieru.",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, kartón",
        kind: "decoupage, lepenie, cardmaking",
        id: 18
      },
      {
        pictutes: ['/static/images/vianoce/vianoce23.jpg','/static/images/vianoce/vianoce24.jpg','/static/images/vianoce/vianoce25.jpg'],
        title: "Srnky - 5 €",
        subtitle: "Pohľadnica",
        details: "...LEN JEDINÝ KÚSOK :) s týmto podkladovým papierom... ...čarovné chvíle v zasneženom lese so srnčou rodinkou :) ...túto roztomilú pohľadničku som vyzdobila motívom, ktorý som vyrobila technikou decoupage, ručne vyrezala a nalepila v 3D efekte na krásny scrapbook papier s bodkami :), pohľadničku som na voľno previazala bielou ľanovou šnúrkou a dozdobila pečiatkou. Pohľadnička á ručne robený základ perlovobielej farby, bez textov. Posielam s ručne robenou obálkou na mieru.",
        size: "15 x 10,5 cm",
        material: "archivačný papier, špagát, obyčajný papier",
        kind: "decoupage, lepenie, cardmaking",
        id: 17
      },
      {
        pictutes: ['/static/images/vianoce/vianoce26.jpg','/static/images/vianoce/vianoce27.jpg','/static/images/vianoce/vianoce28.jpg'],
        title: "❄Zvieratká v zime❄ - 3,60 €",
        subtitle: "Pohľadnica",
        details: "...otváracia vianočná pohľadnica s motívom lesných zvieratiek, ten bol vytvorený technikou decoupage. Pohľadnica je vrstvená, vnútro a zadná strana bez textov v krémovej farbe. Posielam s ručne robenou obálkou.",
        size: "...cca 15 x 10,5 cm",
        material: "obyčajný papier, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 16
      },
      {
        pictutes: ['/static/images/vianoce/vianoce29.jpg','/static/images/vianoce/vianoce30.jpg','/static/images/vianoce/vianoce31.jpg'],
        title: "❄Zima v lese❄ - 3,60 €",
        subtitle: "Pohľadnica",
        details: "...otváracia vianočná pohľadnica s motívom lesných zvieratiek, ten bol vytvorený technikou decoupage. Pohľadnica je vrstvená, vnútro a zadná strana bez textov v krémovej farbe. Posielam s ručne robenou obálkou.",
        size: "...cca 15 x 10,5 cm",
        material: "obyčajný papier, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 15
      },
      {
        pictutes: ['/static/images/vianoce/vianoce32.jpg','/static/images/vianoce/vianoce33.jpg','/static/images/vianoce/vianoce34.jpg','/static/images/vianoce/vianoce35.jpg'],
        title: "Vlk - 5,40 €",
        subtitle: "Pohľadnica",
        details: "...SKLADOM LEN TENTO JEDINEČNÝ KÚSOK ! ...les ukrýva rôznych obyvateľov, najkrajším z nich je nepochybne vlk :) ...zimná pohľadnička s motívom vlka v zasneženom lese, použila som techniku decoupage a ručne rom vyrezala motív vlka, ktorý som nalepila v 3D efekte na krásny scrapbook papier s motívm ihličnatých stromov, pohľadničku som na voľno previazala šnúrkou. Pridanou hodnotou tejto pohľadničky je ručne robená obálka na mieru.",
        size: "15 x 10,5 cm",
        material: "archivačný papier, obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 14
      },
      {
        pictutes: ['/static/images/vianoce/vianoce36.jpg'],
        title: "Dve srnky- 4,10 €",
        subtitle: "Pohľadnica",
        details: "...milá jednoduchá pohľadnička s motívom srniek v zasneženom lese, motív som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte na ručne vyrobený pohľadnicový základ bielej farby. Pohľadničku som na voľno previazala bielohnedým motúzikom. Ku pohľadnici posielam ručne robenú obálku. ",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 13
      },
      {
        pictutes: ['/static/images/vianoce/vianoce37.jpg'],
        title: "Jeleň, laň - 4,40 €",
        subtitle: "Pohľadnica",
        details: "...zimná pohľadnička s motívom jelenej rodinky v zasneženom lese, ten som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte na krásny scrapbook papier s motívom vločiek. Ku pohľadničke posielam ručne robenú obálku :)",
        size: "14,5 x 10,5 cm",
        material: "archivačný papier, obyčajný papier, kartón",
        kind: "decoupage, lepenie, cardmaking",
        id: 12
      },
      {
        pictutes: ['/static/images/vianoce/vianoce38.jpg','/static/images/vianoce/vianoce39.jpg','/static/images/vianoce/vianoce40.jpg','/static/images/vianoce/vianoce41.jpg','/static/images/vianoce/vianoce42.jpg'],
        title: "Anjel - 4,50 €",
        subtitle: "Pohľadnica",
        details: "...LEN JEDINÝ KÚSOK ! ...s týmto anjelom pošlete čaro Vianoc svojim blízkym :) ...vianočná pohľadnica s motívom anjela s nostalgickým nádychom, vytvorila som ju technikou decoupage, ozdobila krásnym scrapbook papierom s bodkami a čipkou, ktorá jemne vykúka spod anjelika, text - čarovné chvíle - je pečiatkovaný. Posielam s ručne robenou obálkou na mieru.",
        size: "15 x 10,5 cm",
        material: "archivačný papier, obyčajný papier, kartón",
        kind: "decoupage, lepenie, cardmaking",
        id: 11
      },
      {
        pictutes: ['/static/images/vianoce/vianoce43.jpg','/static/images/vianoce/vianoce44.jpg','/static/images/vianoce/vianoce45.jpg'],
        title: "Vločka- 3,50 €",
        subtitle: "Pohľadnica",
        details: "...ak budú Vianoce bez snehu, poteší aspoň táto čipkovaná snehová vločka ❄ ...vianočná pohľadnička s motívom vločky sťaby čipkovanej, tú som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte, dozdobila som ju bielou šnúrkou. Pridanou hodnotou tejto pohľadničky je ručne robená obálka na mieru.",
        size: "cca 15 x 10,5 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 10
      },
      {
        pictutes: ['/static/images/vianoce/vianoce46.jpg','/static/images/vianoce/vianoce47.jpg','/static/images/vianoce/vianoce48.jpg'],
        title: "Jeleň - 5,10 €",
        subtitle: "Pohľadnica",
        details: "❄...otváracia pohľadnica s motívom béžového jeleňa, ten bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte na krásny scrapbook papier s motívom stromov v zimnom šate. Celá pohľadnička je na voľno previazaná dvojfarebným motúzikom. Vnútro a zadná strana bez textov v bielej farbe. Posielam s ručne robenou obálkou ❄ ! len jediný kus !",
        size: "...cca 15 x 10,5 cm",
        material: "obyčajný papier, archivačný papier, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 9
      },
      {
        pictutes: ['/static/images/vianoce/vianoce49.jpg','/static/images/vianoce/vianoce50.jpg','/static/images/vianoce/vianoce51.jpg'],
        title: "Jeleň pri stromčeku - 5,10 €",
        subtitle: "Pohľadnica",
        details: "...vianočná pohľadnica s motívom jeleňa, ten bol vyrobený technikou decoupage, precízne ručne vyrezaný a nalepený v 3D efekte na scrapbook papier s trblietavým ihličnatým stromčekom. Pohľadnica je dozdobená papierovými vločkami a previazaná ľanovou šnúrkou. Posielam s ručne robenou obálkou. ! len jediný kus !",
        size: "15 x 10,5 cm",
        material: "archivačný papier, obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 8
      },
      {
        pictutes: ['/static/images/vianoce/vianoce52.jpg','/static/images/vianoce/vianoce53.jpg','/static/images/vianoce/vianoce54.jpg','/static/images/vianoce/vianoce55.jpg'],
        title: "Vločky- 3,60 €",
        subtitle: "Pohľadnica",
        details: "...romantická vianočná pohľadnica s motívom čipkovaných vločiek, tie boli vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D efekte. Pohľadnička je na voľno previazaná bielou ľanovou a béžovou bavlnenou šnúrkou. Pohľadnica je bielej farby bez textov. Posielam s ručne robenou obálkou na mieru.",
        size: "14,5 x 10,5 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 7
      },
      {
        pictutes: ['/static/images/vianoce/vianoce56.jpg','/static/images/vianoce/vianoce57.jpg','/static/images/vianoce/vianoce58.jpg'],
        title: "Šišky - 4,50 €",
        subtitle: "Pohľadnica",
        details: "...všetko sa ligoce, už prišli Vianoce :) ...všetkým priaznivcom prajem krásne prežitie vianočných sviatkov :) ...vianočná pohľadnica so šiškovým venčekom, ten bol vytvorený technikou decoupage, šišky ručne vyrezané a naaranžované do venčeka, ten som dozdobila bieločervenou šnúrkou, maličkou vetvičkou cezmíny a trblietavými hviezdičkami. Pohľadnička je bez textov okrem pečiatky - všetko sa ligoce-. Posielam s ručne robenou obálkou.",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 6
      },
      {
        pictutes: ['/static/images/vianoce/vianoce59.jpg','/static/images/vianoce/vianoce60.jpg','/static/images/vianoce/vianoce61.jpg'],
        title: "Vianočná ruža - 4,50 €",
        subtitle: "Pohľadnica",
        details: "...elegantná pohľadnička s motívom vianočnej ruže, tá bola vytvorená technikou decoupage, ručne vyrezaná a nalepená v 3D efekte, dozdobené červenobielou šnúrkou. Pridanou hodnotou tejto pohľadničky je ručne robená obálka na mieru.",
        size: "cca 15 x 10,5 cm",
        material: "kartón, špagát, obyčajný papier",
        kind: "decoupage, lepenie, cardmaking",
        id: 5
      },
      {
        pictutes: ['/static/images/vianoce/vianoce62.jpg','/static/images/vianoce/vianoce63.jpg','/static/images/vianoce/vianoce64.jpg'],
        title: "Jazvečík- 5,10 €",
        subtitle: "Pohľadnica",
        details: "...milá vianočná pohľadnička s motívom jazvečíka v mikulášskej čiapočke, ktorý čaká na svoj darček :) alebo je ním on?  ...len jediný kus! Psíček bol vytvorený technikou decoupage, ručne fúzik po fúziku vyrezaný a nalepený v 3D efekte na krásny scrapbook papier s motvím vetvičiek, dozdobené červenobielou šnúrkou. Pridanou hodnotou tejto pohľadničky je ručne robená obálka na mieru.",
        size: "15 x 10,5 cm",
        material: "archivačný papier, obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 4
      },
      {
        pictutes: ['/static/images/vianoce/vianoce65.jpg','/static/images/vianoce/vianoce66.jpg','/static/images/vianoce/vianoce67.jpg','/static/images/vianoce/vianoce68.jpg'],
        title: "Červené vločky - 4,50 €",
        subtitle: "Pohľadnica, Visačky",
        details: "...vianočná pohľadnica s motívom červených vločiek, tie boli vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D, dozdobené pečiatkou. Základ pohľadnice je tiež ručne robený v bielej farbe bez textov. Posielam s ručne robenou obálkou. Posielam so sadou visačiek s podobným motívom :)",
        size: "14,5 x 10,5 cm",
        material: "obyčajný papier, kartón",
        kind: "decoupage, lepenie, cardmaking",
        id: 3
      },
      {
        pictutes: ['/static/images/vianoce/vianoce69.jpg','/static/images/vianoce/vianoce70.jpg','/static/images/vianoce/vianoce71.jpg','/static/images/vianoce/vianoce72.jpg','/static/images/vianoce/vianoce73.jpg','/static/images/vianoce/vianoce74.jpg'],
        title: "Vianočná ruža veselé vianoce - 4,50 €",
        subtitle: "Pohľadnica, Visačky",
        details: "...vianočná pohľadnica s vianočnou ružou, tá bola vytvorená technikou decoupage, ručne vyrezaná a nalepená v 3D efekte, nápis Veselé Vianoce je nálepka. Pohľadnica je vrstvená, bez textov a v bielej farbe. Posielam s ručne robenou obálkou a sadou visačiek 4 ks.",
        size: "... 15 x 10,5 cm",
        material: "obyčajný papier, kartón",
        kind: "decoupage, lepenie, cardmaking",
        id: 2
      },
      {
        pictutes: ['/static/images/vianoce/vianoce75.jpg','/static/images/vianoce/vianoce76.jpg','/static/images/vianoce/vianoce77.jpg','/static/images/vianoce/vianoce78.jpg'],
        title: "Vtáčik- 3,60 €",
        subtitle: "Pohľadnica",
        details: "...zimná pohľadnica s milým motívom vtáčika v štrikovanej čiapočke, ktorý bol vytvorený technikou decoupage, nalepený v 3D efekte. Pohľadnica je na voľno previazaná červenobielym motúzikom a dozdobená nálepkou - v teple -. Posielam s pevnou ručne robenou obálkou.",
        size: "14,5 x 10,5 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 1
      }
    ])
    return {
      data,
      id
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Vianoce.vue